import { defineMessages } from '@cookbook/solid-intl'

// Split out of `referral-center.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Learn about referrals on Lodgr. Invite friends, earn rewards, and get more value from every booking.',
        id: 'ReferralCenter.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Referrals | Lodgr',
        id: 'ReferralCenter.titleMessage',
    }),
}
